import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import axios from "../../datasource/axios";
import "./newClientRequestForm.scss";
import { useState, useEffect, useRef } from "react";
import { hasDisallowedNameCharacters, buildDisallowedNameCharsMessage } from "../../utils/nameValidation";
import {
  getTimezoneDropdownList,
  getDropdownValues,
  getContractedByCountry,
  getFilteredSegmentAttributes,
  getFilteredTotalClientsByManager,
  getparentandultimateclientAttributes,
  getChannelDropdownList,
  getParentClientStartDate
} from "./dropdownService";
import {
  SAVECPPREQUEST_URL,
  ValidateClientCode_URL,
  ValidateClientName_URL,
  ValidateParentandUltimateClient_URL,
  DRP_DEFAULT_CODE,
  DRP_DEFAULT_NAME,
  DEFAULT_MAIL,
  NEWCPPREQUEST,
  NEWCLIENTREQUEST
} from "../../constants";

import { NavLink, useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Spinner from "../../components/shared/spinner";
import { Toast } from "primereact/toast";
import { hideLoader } from "../../datasource/msal";
import { Steps } from 'primereact/steps';
import img from '../../assets/CreateClient.svg';
import { Card } from "primereact/card";

export const NewClientRequestForm = (props: any) => {
  const BASE_URL = process.env.REACT_APP_API_URI as string;
  const [showLoader, setShowLoader] = useState(false);
  const [requestDetails, setRequestDetails] = useState({});
  const [isVisibleDiv1, setVisibleDiv1] = useState(true);
  const [isVisibleDiv2, setVisibleDiv2] = useState(false);
  const [isVisibleDiv3, setVisibleDiv3] = useState(false);
  const [isVisibleDiv4, setVisibleDiv4] = useState(false);
  const [isVisibleDiv5, setVisibleDiv5] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [spinnerClassName, setSpinnerClassName] = useState("");
  const [showAllocations, setShowAllocations] = useState(false);
  const [segments, setSegments] = useState<DropdownData[]>([]);
  const [timezones, setTimezones] = useState<DropdownData[]>([]);
  const [channelTypes, setChannelTypes] = useState<DropdownData[]>([]);
  const [segmentAttributes, setSegmentAttributes] = useState<DropdownData[]>([]);
  const [verticalAttributes, setVerticalAttributes] = useState<DropdownData[]>([]);
  const [geoAttributes, setGeoAttributes] = useState<DropdownData[]>([]);
  const [clientPortfolio, setClientPortfolio] = useState<DropdownData[]>([]);
  const [engageSegments, setEngageSegments] = useState<DropdownData[]>([]);
  const [clientTypes, setClientTypes] = useState<DropdownData[]>([]);
  const [newParentNeededOptions, setNewParentNeededOptions] = useState<DropdownData[]>([]);
  const [hyperGrowthClients, setHyperGrowthClients] = useState<DropdownData[]>([]);
  const [clientRollups, setClientRollups] = useState<DropdownData[]>([]);
  const [cmsCgsSegments, setCmsCgsSegments] = useState<DropdownData[]>([]);
  const [allocations, setAllocations] = useState<DropdownData[]>([]);
  const [legalEntities, setLegalEntities] = useState<DropdownData[]>([]);
  const [contractByCountry, setContractByCountry] = useState("");
  const [totalClients, setTotalClients] = useState<DropdownData[]>([]);
  const [divHeight, setDivHeight] = useState("");
  const [visible, setVisible] = useState(false);
  const [perceptaId, setPerceptaId] = useState("");
  const [noneId, setNoneId] = useState("");
  const [test, setTest] = useState([]);
  const [text, setText] = useState("");
  const toast = useRef<any>(null);
  const nameRef = useRef<any>();
  const clientnameRef = useRef<any>();
  const parentClientRef = useRef<any>();
  const ultimateClientRef = useRef<any>();
  const opsvpRef = useRef<any>();
  const managedbyRef = useRef<any>();

  // Custom channel dropdown state
  const [channelDropdownOpen, setChannelDropdownOpen] = useState(false);
  const channelDropdownRef = useRef<any>(null);

  const [isNewParentNeeded, setIsNewParentNeeded] = useState("");
  const [isNewUltimateParentNeeded, setIsNewUltimateParentNeeded] = useState("");
  const [parentClientResponse, setParentClientResponse] = useState<DropdownData[]>([]);
  const [ultimateParentResponse, setUltimateParentResponse] = useState<DropdownData[]>([]);
  const [segmentname, setSegmentName] = useState("");
  const [supportgroups, setSupportGroups] = useState<DropdownData[]>([]);
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [items, setItems] = useState<any>([]);
  const [issubmit, setissubmit] = useState(false);
  const [issave, setissave] = useState(false);
  const [issubmitsuccess, setissubmitsuccess] = useState(false);
  const [issavesuccess, setissavesuccess] = useState(false);
  const [isreadonly, setisreadonly] = useState(false);
  const [parentClientStartDate, setParentClientStartDate] = useState<Date | null>(null);
  // Close channel dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (channelDropdownRef.current && !channelDropdownRef.current.contains(e.target)) {
        setChannelDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function navigateHome() {
    if (!showHeader) {
      HideDialog(true);
    } else {
      navigate(NEWCPPREQUEST);
    }
  }

  function HideDialog(showAlert: boolean) {
    props.CPPEditForm(false, showAlert);
  }

  const EditForm = (val: any) => {
    setVisible(val);
  };

  let onHideShowClick = (divId: number) => {
    setActiveIndex(divId);
    setissave(false);
    setissubmit(false);
    setChannelDropdownOpen(false);
    if (divId == 0) {
      setVisibleDiv1(true);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      setVisibleDiv5(false);
    }
    if (divId == 1) {
      setVisibleDiv1(false);
      setVisibleDiv2(true);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      setVisibleDiv5(false);
    }
    if (divId == 2) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(true);
      setVisibleDiv4(false);
      setVisibleDiv5(false);
    }
    if (divId == 3) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(true);
      setVisibleDiv5(false);
    }
    if (divId == 4) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      if (segmentname === "Engage" || segmentname === "Percepta" || segmentname === "Digital") {
        setVisibleDiv5(true);
      } else {
        setVisibleDiv5(false);
      }
    }
    if (divId == 5) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      setVisibleDiv5(false);
    }
  }

  const formik: any = useFormik({
    initialValues: {
      number: "",
      defaultAliasName: "",
      clientReportingAliasName: "",
      clientType: { name: "", code: "" },
      newParentNeeded: { name: "", code: "" },
      parentTotalClients: "",
      newParentNeededHyperion: { name: "", code: "" },
      parentTotalClientsHyperion: "",
      segmentAttribute: { name: "", code: "" },
      segmentAttributeAlloc: { name: "", code: "" },
      verticalAttribute: { name: "", code: "" },
      geoAttribute: { name: "", code: "" },
      clientPortfolio: { name: "", code: "" },
      siteAllocations: { name: "", code: "" },
      countryAllocations: { name: "", code: "" },
      regionalAllocations: { name: "", code: "" },
      cmsCgsAllocations: { name: "", code: "" },
      engageSegmentAllocations: { name: "", code: "" },
      siteAllocationsAtHome: { name: "", code: "" },
      segmentAllocations: { name: "", code: "" },
      siteAllocationsFcr: { name: "", code: "" },
      countryAllocationsFcr: { name: "", code: "" },
      corpAllocations: { name: "", code: "" },
      alternateClientRollups1: { name: "", code: "" },
      alternateClientRollups2: { name: "", code: "" },
      hypergrowthClient: { name: "", code: "" },
      legalEntity: { name: "", code: "" },
      contractByCountry: { name: "", code: "" },
      totalClientsByManager: { name: "", code: "" },
      timezone: { name: "", code: "" },
      channeltype: [] as DropdownData[],
      requestedStartDate: "",
      managedBy: "",
      supportGroups: { name: "", code: "" },
      opsVP: ""
    },
    validate: (data) => {
      let errors = {
        number: "",
        defaultAliasName: "",
        clientReportingAliasName: "",
        clientType: "",
        newParentNeeded: "",
        parentTotalClients: "",
        newParentNeededHyperion: "",
        parentTotalClientsHyperion: "",
        segmentAttribute: "",
        segmentAttributeAlloc: "",
        verticalAttribute: "",
        geoAttribute: "",
        clientPortfolio: "",
        siteAllocations: "",
        countryAllocations: "",
        regionalAllocations: "",
        cmsCgsAllocations: "",
        engageSegmentAllocations: "",
        siteAllocationsFcr: "",
        countryAllocationsFcr: "",
        corpAllocations: "",
        legalEntity: "",
        totalClientsByManager: "",
        timezone: "",
        channeltype: "",
        managedBy: "",
        supportGroups: "",
        opsVP: ""
      };

      if (!data.number) {
        errors.number = "Requested Number is required.";
      }

      if (!data.clientReportingAliasName) {
        errors.clientReportingAliasName = "Reporting Alias Name is required.";
      }

      if (!data.clientType || data.clientType.name === null || data.clientType.name === "" || data.clientType.name === undefined) {
        errors.clientType = "Client Type is required";
      }

      if (!data.newParentNeeded || data.newParentNeeded.name === null || data.newParentNeeded.name === "" || data.newParentNeeded.name === undefined) {
        errors.newParentNeeded = "New Parent Needed (EIG) is required";
      }

      if (!data.parentTotalClients) {
        errors.parentTotalClients = "Parent in Total Clients (EIG) is required";
      }

      if (!data.newParentNeededHyperion || data.newParentNeededHyperion.name === null || data.newParentNeededHyperion.name === "" || data.newParentNeededHyperion.name === undefined) {
        errors.newParentNeededHyperion = "New Parent Needed (Hyperion) is required";
      }

      if (!data.parentTotalClientsHyperion) {
        errors.parentTotalClientsHyperion = "Parent in Total Clients (Hyperion) is required";
      }

      if (!data.segmentAttribute || data.segmentAttribute.name === null || data.segmentAttribute.name === "" || data.segmentAttribute.name === undefined) {
        errors.segmentAttribute = "Segment Attribute is required";
      }

      if (data.segmentAttributeAlloc.name === "" || data.segmentAttributeAlloc.name === undefined || data.segmentAttributeAlloc.name === null) {
        errors.segmentAttributeAlloc = "Segment is required";
      }

      if (!data.verticalAttribute || data.verticalAttribute.name === null || data.verticalAttribute.name === "" || data.verticalAttribute.name == undefined) {
        errors.verticalAttribute = "Vertical Attribute is required";
      }

      if (!data.geoAttribute || data.geoAttribute.name === null || data.geoAttribute.name === "" || data.geoAttribute.name === undefined) {
        errors.geoAttribute = "Geo Attribute is required";
      }

      if (!data.clientPortfolio || data.clientPortfolio.name === null || data.clientPortfolio.name === "" || data.clientPortfolio.name === undefined) {
        errors.clientPortfolio = "Client Portfolio is required";
      }

      if (!data.siteAllocations || data.siteAllocations.name === null || data.siteAllocations.name === "" || data.siteAllocations.name === undefined) {
        if (formik.values.segmentAttributeAlloc && (formik.values.segmentAttributeAlloc.name != "Percepta" || formik.values.segmentAttributeAlloc.name == undefined)) {
          errors.siteAllocations = "Site Allocations is required";
        } else {
          if (formik.values.segmentAttributeAlloc.name == undefined) {
            errors.siteAllocations = "Site Allocations is required";
          }
        }
      }

      if (!data.siteAllocations || data.siteAllocations.name === null || data.siteAllocations.name === "" || data.siteAllocations.name === undefined) {
        if (formik.values.segmentAttributeAlloc) {
          if (formik.values.segmentAttributeAlloc.name != "Percepta") {
            errors.countryAllocations = "Country Allocations is required";
          } else {
            errors.countryAllocations = "";
          }
        } else {
          errors.countryAllocations = "Country Allocations is required";
        }
      }

      if (!data.regionalAllocations || data.regionalAllocations.name === null || data.regionalAllocations.name === "" || data.regionalAllocations.name === undefined) {
        if (formik.values.segmentAttributeAlloc && (formik.values.segmentAttributeAlloc.name != "Percepta" || formik.values.segmentAttributeAlloc.name == undefined)) {
          errors.regionalAllocations = "Regional Allocations is required";
        } else {
          if (formik.values.segmentAttributeAlloc.name == undefined) {
            errors.regionalAllocations = "Regional Allocations is required";
          }
        }
      }

      if (!data.cmsCgsAllocations || data.cmsCgsAllocations.name === null || data.cmsCgsAllocations.name === "" || data.cmsCgsAllocations.name === undefined) {
        if (formik.values.segmentAttributeAlloc && (formik.values.segmentAttributeAlloc.name != "Percepta" || formik.values.segmentAttributeAlloc.name == undefined)) {
          errors.cmsCgsAllocations = "CMS/CGS Allocations is required";
        } else {
          if (formik.values.segmentAttributeAlloc.name == undefined) {
            errors.cmsCgsAllocations = "CMS/CGS Allocations is required";
          }
        }
      }

      if (!data.engageSegmentAllocations || data.engageSegmentAllocations.name === null || data.engageSegmentAllocations.name === "" || data.engageSegmentAllocations.name === undefined) {
        if (formik.values.segmentAttributeAlloc && (formik.values.segmentAttributeAlloc.name != "Percepta" || formik.values.segmentAttributeAlloc.name == undefined)) {
          errors.engageSegmentAllocations = "Engage Segment Allocations is required";
        } else {
          if (formik.values.segmentAttributeAlloc.name == undefined) {
            errors.engageSegmentAllocations = "Engage Segment Allocations is required";
          }
        }
      }

      if (!data.siteAllocationsFcr || data.siteAllocationsFcr.name === null || data.siteAllocationsFcr.name === "" || data.siteAllocationsFcr.name === undefined) {
        errors.siteAllocationsFcr = "Site Allocations is required";
      }

      if (!data.countryAllocationsFcr || data.countryAllocationsFcr.name === null || data.countryAllocationsFcr.name === "" || data.countryAllocationsFcr.name === undefined) {
        errors.countryAllocationsFcr = "Country Allocations is required";
      }

      if (!data.corpAllocations || data.corpAllocations.name === null || data.corpAllocations.name === "" || data.corpAllocations.name === undefined) {
        errors.corpAllocations = "Corporate Allocations is required";
      }

      if (!data.totalClientsByManager || data.totalClientsByManager.name === null || data.totalClientsByManager.name === "" || data.totalClientsByManager.name === undefined) {
        errors.totalClientsByManager = "Total Clients -By Manager is required";
      }

      if (!data.legalEntity || data.legalEntity.name === null || data.legalEntity.name === "" || data.legalEntity.name === undefined) {
        errors.legalEntity = "Contracting Entity is required";
      }

      if (!data.timezone || data.timezone.name === null || data.timezone.name === "" || data.timezone.name === undefined) {
        errors.timezone = "Timezone is required.";
      }

      if (data.segmentAttributeAlloc.name === "Engage" || data.segmentAttributeAlloc.name === "Percepta" || data.segmentAttributeAlloc.name === "Digital") {
        if (!data.managedBy || data.managedBy === null || data.managedBy === "" || data.managedBy === undefined) {
          errors.managedBy = "Managed By is required.";
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(data.managedBy)) {
          errors.managedBy = 'Managed By Email is Invalid'
        }

        if (!data.opsVP || data.opsVP === null || data.opsVP === "" || data.opsVP === undefined) {
          errors.opsVP = "Ops VP is required.";
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(data.opsVP)) {
          errors.opsVP = 'Ops VP Email is Invalid'
        }

        if (data.supportGroups.name === "" || data.supportGroups.name === undefined || data.supportGroups === null) {
          errors.supportGroups = "Security Group is required.";
        }
      }
      return errors;
    },
    onSubmit: (data) => {
      formik.resetForm();
    },
  });

  var hyperGrowthClassName = !showHeader
    ? "left-align right-padding-wide"
    : "left-align right-padding-wide hypergrowthclient-normal-class";

  var clientRollupsClassName = !showHeader ? "client-rollups-form-adjusted" : "client-rollups-form";
  var clientNamingClassName = !showHeader ? "client-naming-form-adjusted" : "client-naming-form";

  function scrollToTop() {
    window.scrollTo(0, 0);
  }

  function populateForm() {
    if (props.requestDetails) {
      formik.values.number = props.requestDetails["requestedNumber"];
      setText(props.requestDetails["requestedNumber"]);
      formik.values.defaultAliasName = props.requestDetails["defaultAliasName"];
      formik.values.clientReportingAliasName = props.requestDetails["clientReportingAliasName"];
      formik.values.contractByCountry = props.requestDetails["contractByCountry"];
      const startDate = new Date(props.requestDetails["requestedStartDate"]);
      formik.values.requestedStartDate = startDate;
      formik.values.managedBy = props.requestDetails["managedBy"];
      formik.values.opsVP = props.requestDetails["opsVP"];
      formik.values.SupportGroupName = props.requestDetails["supportgroupName"];
    }
    setShowLoader(false);
    setSpinnerClassName("divSpinner");
  }

  useEffect(() => {
    loadDropdowns();
    setShowAllocations(true);
    setShowHeader(props.showHeader);
    setRequestDetails(props.requestDetails);
    if (!props.showHeader) {
      setSegmentName(props.requestDetails["segmentAttributeAlloc"]);
    }

    if ((props.mode === "Edit" || props.mode === "View") && (props.requestDetails["segmentAttributeAlloc"] === "Engage" || props.requestDetails["segmentAttributeAlloc"] === "Percepta" || props.requestDetails["segmentAttributeAlloc"] === "Digital")) {
      setaddlvisibleforms();
    } else {
      setvisibleforms();
    }
  }, []);

  const getCode = (name: string, collection: any) => {
    var codeIdx = -1;
    for (var i = 0; i < collection.length; i++) {
      if (name == "Engage") {
        var x = collection[i].name === name;
      }
      if (collection[i].name === name) {
        codeIdx = collection[i].code;
        if (codeIdx === undefined) {
          codeIdx = collection[i].id;
        }
        break;
      }
    }
    return codeIdx.toString();
  };

  interface DropdownData {
    name: string;
    code: string;
  }

  interface TimezoneResponse {
    timezones: DropdownData[];
  }

  interface ChannelTypeResponse {
    channeltypes: DropdownData[];
  }

  interface DropdownResponse {
    codes: DropdownData[];
  }

  const loadDropdowns = async () => {
    setSpinnerClassName("divSpinner bringToFront");
    setShowLoader(true);

    try {
      const [
        timezoneresponse,
        channeltypeResponse,
        segmentResponse,
        segAttrResponse,
        verAttrResponse,
        geoAttrResponse,
        clientPortfolioResponse,
        engSegmentsResponse,
        clientTypesResponse,
        newParentResponse,
        hyperGrowthResponse,
        clientRollupsResponse,
        cmsSegmentsResponse,
        allocationsResponse,
        legalEntitiesResponse,
        totalClientsResponse,
        newParentClientResponse,
        newUltimateParentClientResponse,
        supgrpResponse
      ] = await Promise.all([
        getTimezoneDropdownList(),
        getChannelDropdownList(),
        getDropdownValues("segments"),
        getDropdownValues("segmentattributes"),
        getDropdownValues("verticalattributes"),
        getDropdownValues("geoattributes"),
        getDropdownValues("clientportfolio"),
        getDropdownValues("engage_segments"),
        getDropdownValues("client_types"),
        getDropdownValues("new_parent_needed_options"),
        getDropdownValues("hyper_growth_clients"),
        getDropdownValues("client_rollups"),
        getDropdownValues("cms_cgs_segments"),
        getDropdownValues("allocations"),
        getDropdownValues("legal_entities"),
        getDropdownValues("totalclientsbymanager"),
        getparentandultimateclientAttributes("p"),
        getDropdownValues("totalclientparents"),
        getDropdownValues("asknow_support_groups")
      ]);

      const timezoneCodes = (timezoneresponse as TimezoneResponse)?.timezones;
      setTimezones(timezoneCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["timezonename"];
        let idx = getCode(name, timezoneCodes);
        formik.values.timezone = { name, code: idx };
      }

      const channeltypeCodes = (channeltypeResponse as ChannelTypeResponse)?.channeltypes;
      setChannelTypes(channeltypeCodes);
      const defaultChannel = channeltypeCodes?.find((c: any) => c.code === "1");

      if (!props.showHeader) {
        let name = props.requestDetails["channelTypeName"];
        if (name) {
          const names = name.split("|").map((n: string) => n.trim());
          formik.values.channeltype = names
            .map((n: string) => {
              const idx = getCode(n, channeltypeCodes);
              return { name: n, code: idx };
            })
            .filter((c: DropdownData) => c.code !== "-1");
        } else {
          if (defaultChannel) formik.values.channeltype = [defaultChannel];
        }
      } else {
        if (defaultChannel) formik.values.channeltype = [defaultChannel];
      }

      const segmentCodes = (segmentResponse as DropdownResponse)?.codes;
      setSegments(segmentCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["segmentAttributeAlloc"];
        let idx = getCode(name, segmentCodes);
        formik.values.segmentAttributeAlloc = { name, code: idx };
        if (name === "Percepta") {
          setShowAllocations(false);
          setDivHeight("800px");
        } else {
          setShowAllocations(true);
          setDivHeight("1280px");
        }
        name = props.requestDetails["segmentAllocationsAtHome"];
        idx = getCode(name, segmentCodes);
        formik.values.segmentAllocations = { name, code: idx };
      }

      const segmentAttrCodes = (segAttrResponse as DropdownResponse)?.codes;
      setSegmentAttributes(segmentAttrCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["segmentAttribute"];
        let idx = getCode(name, segmentAttrCodes);
        formik.values.segmentAttribute = { name, code: idx };
      }

      const verAttrCodes = (verAttrResponse as DropdownResponse)?.codes;
      setVerticalAttributes(verAttrCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["verticalAttribute"];
        let idx = getCode(name, verAttrCodes);
        formik.values.verticalAttribute = { name, code: idx };
      }

      const geoAttrCodes = (geoAttrResponse as DropdownResponse)?.codes;
      setGeoAttributes(geoAttrCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["geoAttribute"];
        let idx = getCode(name, geoAttrCodes);
        formik.values.geoAttribute = { name, code: idx };
      }

      const clientPortfolioCodes = (clientPortfolioResponse as DropdownResponse)?.codes;
      setClientPortfolio(clientPortfolioCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["clientPortfolio"];
        let idx = getCode(name, clientPortfolioCodes);
        formik.values.clientPortfolio = { name, code: idx };
      }

      const engageSegmentCodes = (engSegmentsResponse as DropdownResponse)?.codes;
      setEngageSegments(engageSegmentCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["engageSegmentAllocations"];
        let idx = getCode(name, engageSegmentCodes);
        formik.values.engageSegmentAllocations = { name, code: idx };
      }

      const clientTypesCodes = (clientTypesResponse as DropdownResponse)?.codes;
      setClientTypes(clientTypesCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["clientType"];
        let idx = getCode(name, clientTypesCodes);
        formik.values.clientType = { name, code: idx };
      }

      const newParentCodes = (newParentResponse as DropdownResponse)?.codes;
      setNewParentNeededOptions(newParentCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["newParentNeededEig"];
        let idx = getCode(name, newParentCodes);
        formik.values.newParentNeeded = { name, code: idx };

        name = props.requestDetails["newParentNeededHyperion"];
        idx = getCode(name, newParentCodes);
        formik.values.newParentNeededHyperion = { name, code: idx };

        setIsNewParentNeeded(formik.values.newParentNeeded["name"] === "Yes" ? "1" : "0");
        setIsNewUltimateParentNeeded(formik.values.newParentNeededHyperion["name"] === "Yes" ? "1" : "0");
      }

      const hyperGrowthCodes = (hyperGrowthResponse as DropdownResponse)?.codes;
      setHyperGrowthClients(hyperGrowthCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["hyperGrowthClient"];
        let idx = getCode(name, hyperGrowthCodes);
        formik.values.hypergrowthClient = { name, code: idx };
      }

      const clientRollupsCodes = (clientRollupsResponse as DropdownResponse)?.codes;
      setClientRollups(clientRollupsCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["alternateClientRollups1"];
        let idx = getCode(name, clientRollupsCodes);
        formik.values.alternateClientRollups1 = { name, code: idx };

        name = props.requestDetails["alternateClientRollups2"];
        idx = getCode(name, clientRollupsCodes);
        formik.values.alternateClientRollups2 = { name, code: idx };
      }

      const cmsSegmentsCodes = (cmsSegmentsResponse as DropdownResponse)?.codes;
      setCmsCgsSegments(cmsSegmentsCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["cmsCgsAllocations"];
        let idx = getCode(name, cmsSegmentsCodes);
        formik.values.cmsCgsAllocations = { name, code: idx };
      }

      const allocationsCodes = (allocationsResponse as DropdownResponse)?.codes;
      setAllocations(allocationsCodes);
      if (!props.showHeader) {
        let allocationNames = [
          "siteAllocations", "countryAllocations", "regionalAllocations",
          "siteAllocationsFcr", "countryAllocationsFcr", "siteAllocationsAtHome",
          "corpAllocations"
        ];
        allocationNames.forEach((name) => {
          let idx = getCode(props.requestDetails[name], allocationsCodes);
          formik.values[name] = { name: props.requestDetails[name], code: idx };
        });
      }

      const legalEntitiesCodes = (legalEntitiesResponse as DropdownResponse)?.codes;
      setLegalEntities(legalEntitiesCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["legalEntity"];
        let idx = getCode(name, legalEntitiesCodes);
        formik.values.legalEntity = { name, code: idx };
        setContractByCountry(props.requestDetails["contractByCountry"]);
      }

      const totalClientsCodes = (totalClientsResponse as DropdownResponse)?.codes;
      setTotalClients(totalClientsCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["totalClientsByManager"];
        let idx = getCode(name, totalClientsCodes);
        formik.values.totalClientsByManager = { name, code: idx };
      }

      const parentClientCodes = (newParentClientResponse as DropdownResponse)?.codes;
      setParentClientResponse(parentClientCodes);

      if (!props.showHeader && formik.values.newParentNeeded.name === "No") {
        const name = props.requestDetails["parentInTotalClientsEig"];
        const id = getCode(name, parentClientResponse);
        formik.values.parentTotalClients = {};
        formik.values.parentTotalClients["name"] = name;
        formik.values.parentTotalClients["code"] = id;
      }
      if (!props.showHeader && formik.values.newParentNeeded.name === "Yes") {
        formik.values.parentTotalClients = props.requestDetails["parentInTotalClientsEig"];
      }

      const ultimateParentCodes = (newUltimateParentClientResponse as DropdownResponse)?.codes;
      setUltimateParentResponse(ultimateParentCodes);

      if (!props.showHeader && formik.values.newParentNeededHyperion.name === "No") {
        const name = props.requestDetails["parentInTotalClientsHyperion"];
        const id = getCode(name, ultimateParentResponse);
        formik.values.parentTotalClientsHyperion = {};
        formik.values.parentTotalClientsHyperion["name"] = name;
        formik.values.parentTotalClientsHyperion["code"] = id;
      }
      if (!props.showHeader && formik.values.newParentNeededHyperion.name === "Yes") {
        formik.values.parentTotalClientsHyperion = props.requestDetails["parentInTotalClientsHyperion"];
      }

      const supportGroupsCodes = (supgrpResponse as DropdownResponse)?.codes;
      setSupportGroups(supportGroupsCodes);
      if (!props.showHeader) {
        let name = props.requestDetails["supportGroupName"];
        let idx = getCode(name, supportGroupsCodes);
        formik.values.supportGroups = { name, code: idx };
      }

      setPerceptaId(getCode("Percepta", supportGroupsCodes));
      setNoneId(getCode("Unused No Segment", supportGroupsCodes));

      setSpinnerClassName("divSpinner");
      populateForm();
    } catch (error) {
      console.error("Error loading dropdowns:", error);
    } finally {
      setTimeout(() => {
        setShowLoader(false);
      }, 5000);
    }
  };

  useEffect(() => {
    if (!props.showHeader && formik.values.newParentNeeded.name === "No") {
      const name = props.requestDetails["parentInTotalClientsEig"];
      const id = getCode(name, parentClientResponse);
      formik.values.parentTotalClients = {};
      formik.values.parentTotalClients["name"] = name;
      formik.values.parentTotalClients["code"] = id;
    }
    if (!props.showHeader && formik.values.newParentNeeded.name === "Yes") {
      formik.values.parentTotalClients = props.requestDetails["parentInTotalClientsEig"];
    }
  }, [parentClientResponse]);

  useEffect(() => {
    if (!props.showHeader && formik.values.newParentNeededHyperion.name === "No") {
      const name = props.requestDetails["parentInTotalClientsHyperion"];
      const id = getCode(name, ultimateParentResponse);
      formik.values.parentTotalClientsHyperion = {};
      formik.values.parentTotalClientsHyperion["name"] = name;
      formik.values.parentTotalClientsHyperion["code"] = id;
    }
    if (!props.showHeader && formik.values.newParentNeededHyperion.name === "Yes") {
      formik.values.parentTotalClientsHyperion = props.requestDetails["parentInTotalClientsHyperion"];
    }
  }, [ultimateParentResponse]);

  const getSegmentAttributeId = (name: string, collection: any) => {
    const prIdx = collection.findIndex((obj: any) => obj.name === name);
    if (prIdx < 0) {
      return "-1";
    }
    return collection[prIdx]["code"];
  };

  const getId = (name: string, collection: any) => {
    var prIdx = collection.findIndex(
      (v: { [x: string]: any }) => v["name"] === formik.values[name].name
    );
    if (prIdx < 0) {
      return 0;
    }
    if (name === 'timezone') {
      var id = collection[prIdx]["code"];
      return id;
    }
    return prIdx;
  };

  const sleep = async (milliseconds: number) => {
    await new Promise((resolve) => {
      return setTimeout(resolve, milliseconds);
    });
  };

  const saveCPPRequest = async (isSubmitted: boolean) => {
    var cppRequest: any = [];

    if (isSubmitted) {
      setissubmit(isSubmitted);
      setissave(!isSubmitted);

      const v = formik.values;
      const newArr: any[] = [];

      if (!v.number) newArr.push(<li>Requested Number is required.</li>);
      if (!v.clientReportingAliasName) newArr.push(<li>Reporting Alias Name is required.</li>);
      if (!v.clientType?.name) newArr.push(<li>Client Type is required.</li>);
      if (!v.newParentNeeded?.name) newArr.push(<li>New Parent Needed (EIG) is required.</li>);
      if (!v.parentTotalClients && !v.parentTotalClients?.name) newArr.push(<li>Parent in Total Clients (EIG) is required.</li>);
      if (!v.newParentNeededHyperion?.name) newArr.push(<li>New Parent Needed (Hyperion) is required.</li>);
      if (!v.parentTotalClientsHyperion && !v.parentTotalClientsHyperion?.name) newArr.push(<li>Parent in Total Clients (Hyperion) is required.</li>);
      if (!v.segmentAttribute?.name) newArr.push(<li>Segment Attribute is required.</li>);
      if (!v.segmentAttributeAlloc?.name) newArr.push(<li>Segment is required.</li>);
      if (!v.verticalAttribute?.name) newArr.push(<li>Vertical Attribute is required.</li>);
      if (!v.geoAttribute?.name) newArr.push(<li>Geo Attribute is required.</li>);
      if (!v.clientPortfolio?.name) newArr.push(<li>Client Portfolio is required.</li>);
      if (!v.legalEntity?.name) newArr.push(<li>Contracting Entity is required.</li>);
      if (!v.totalClientsByManager?.name) newArr.push(<li>Total Clients By Manager is required.</li>);
      if (!v.timezone?.name) newArr.push(<li>Timezone is required.</li>);
      if (v.requestedStartDate && parentClientStartDate && v.requestedStartDate < parentClientStartDate) {
        newArr.push(<li>Requested Start Date cannot be earlier than parent client start date ({parentClientStartDate.toLocaleDateString()}).</li>);
      }
      if (!v.corpAllocations?.name) newArr.push(<li>Corp Allocations is required.</li>);
      if (!v.siteAllocationsFcr?.name) newArr.push(<li>Site Allocations (FCR) is required.</li>);
      if (!v.countryAllocationsFcr?.name) newArr.push(<li>Country Allocations (FCR) is required.</li>);

      if (v.segmentAttributeAlloc?.name !== "Percepta") {
        if (!v.siteAllocations?.name) newArr.push(<li>Site Allocations is required.</li>);
        if (!v.countryAllocations?.name) newArr.push(<li>Country Allocations is required.</li>);
        if (!v.regionalAllocations?.name) newArr.push(<li>Regional Allocations is required.</li>);
        if (!v.cmsCgsAllocations?.name) newArr.push(<li>CMS/CGS Allocations is required.</li>);
        if (!v.engageSegmentAllocations?.name) newArr.push(<li>Engage Segment Allocations is required.</li>);
      }

      if (v.segmentAttributeAlloc?.name === "Engage" || v.segmentAttributeAlloc?.name === "Percepta" || v.segmentAttributeAlloc?.name === "Digital") {
        if (!v.managedBy) newArr.push(<li>Managed By is required.</li>);
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(v.managedBy)) newArr.push(<li>Managed By Email is Invalid.</li>);
        if (!v.opsVP) newArr.push(<li>Ops VP is required.</li>);
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(v.opsVP)) newArr.push(<li>Ops VP Email is Invalid.</li>);
        if (!v.supportGroups?.name) newArr.push(<li>Security Group is required.</li>);
      }

      if (newArr.length > 0) {
        toast.current.show({
          severity: "error",
          summary: "Validation Summary",
          detail: <ul>{newArr}</ul>,
          life: 3000,
        });
        setissubmitsuccess(false);
        setissavesuccess(false);
        return;
      }
    } else {
      setissave(!isSubmitted);
      setissubmit(isSubmitted);
    }
    setShowLoader(true);

    let selectedSiteAllocations = "";
    let selectediteAllocationsAtHome = "";
    let selectedCountryAllocations = "";
    let selectedRegionalAllocations = "";
    let selectedCmsCgsAllocations = "";
    let selectedEngageSegmentAllocations = "";
    let selectedSegmentAllocations = "";

    let selectedSegment = formik.values.segmentAttributeAlloc.name;
    if (selectedSegment != "Percepta") {
      selectedSiteAllocations = formik.values.siteAllocations.name;
      selectediteAllocationsAtHome = formik.values.siteAllocationsAtHome.name;
      selectedCountryAllocations = formik.values.countryAllocations.name;
      selectedRegionalAllocations = formik.values.regionalAllocations.name;
      selectedCmsCgsAllocations = formik.values.cmsCgsAllocations.name;
      selectedEngageSegmentAllocations = formik.values.engageSegmentAllocations.name;
      selectedSegmentAllocations = formik.values.segmentAllocations.name;
    }

    let reqId = "";
    if (props.requestDetails != null) {
      reqId = props.requestDetails["id"];
    }

    let timezone = "";
    if (formik.values.timezone) {
      timezone = formik.values.timezone.name;
    }

    let channeltype = "";
    if (formik.values.channeltype && (formik.values.channeltype as DropdownData[]).length > 0) {
      channeltype = (formik.values.channeltype as DropdownData[]).map(c => c.name).join("|");
    }

    var reqStartDate = "";
    if (formik.values.requestedStartDate) {
      reqStartDate = formik.values.requestedStartDate.getFullYear() + "-" + (formik.values.requestedStartDate.getMonth() + 1) + "-" + formik.values.requestedStartDate.getDate();
    }

    var request = {
      RequestId: reqId,
      RequestedNumber: formik.values.number,
      ClientPortfolioId: getId("clientPortfolio", clientPortfolio),
      ClientPortfolioName: formik.values.clientPortfolio.name,
      CorpAllocationsName: formik.values.corpAllocations.name,
      CorpAllocationsId: getId("corpAllocations", allocations),
      AlternateClientRollups1Id: getId("alternateClientRollups1", clientRollups),
      AlternateClientRollups1Name: formik.values.alternateClientRollups1.name,
      AlternateClientRollups2Id: getId("alternateClientRollups2", clientRollups),
      AlternateClientRollups2Name: formik.values.alternateClientRollups2.name,
      ClientReportingAliasName: formik.values.clientReportingAliasName,
      ClientTypeId: getId("clientType", clientTypes),
      ClientTypeName: formik.values.clientType.name,
      CmsCgsAllocationId: getId("cmsCgsAllocations", cmsCgsSegments),
      CmsCgsAllocationsName: selectedCmsCgsAllocations,
      ContractByCountry: contractByCountry,
      CountryAllocationId: getId("countryAllocations", allocations),
      CountryAllocationsName: selectedCountryAllocations,
      CountryAllocationsFcrId: getId("countryAllocationsFcr", allocations),
      CountryAllocationsFcrName: formik.values.countryAllocationsFcr.name,
      DefaultAliasName: formik.values.number + " " + formik.values.clientReportingAliasName,
      EngageSegmentAllocationId: getId("engageSegmentAllocations", engageSegments),
      EngageSegmentAllocationsName: selectedEngageSegmentAllocations,
      LegalEntityName: formik.values.legalEntity.name,
      LegalEntityId: getId("legalEntity", legalEntities),
      NewParentNeededEigId: getId("newParentNeeded", newParentNeededOptions),
      NewParentNeededEigName: formik.values.newParentNeeded.name,
      NewParentNeededHyperionId: getId("newParentNeededHyperion", newParentNeededOptions),
      NewParentNeededHyperionName: formik.values.newParentNeededHyperion.name,
      ParentInTotalClientsEig: isNewParentNeeded === "1" ? formik.values.parentTotalClients : formik.values.parentTotalClients.name,
      ParentInTotalClientsHyperion: isNewUltimateParentNeeded === "1" ? formik.values.parentTotalClientsHyperion : formik.values.parentTotalClientsHyperion.name,
      RegionalAllocationId: getId("regionalAllocations", allocations),
      RegionalAllocationsName: selectedRegionalAllocations,
      SegmentAllocationsAtHomeId: getId("segmentAllocations", segments),
      SegmentAllocationsAtHomeName: selectedSegmentAllocations,
      SegmentAttributeAllocId: getId("segmentAttributeAlloc", segments),
      SegmentAttributeAllocName: formik.values.segmentAttributeAlloc.name,
      SegmentAttributeId: getSegmentAttributeId(formik.values.segmentAttribute.name, segmentAttributes),
      SegmentAttributeName: formik.values.segmentAttribute.name,
      SiteAllocationId: getId("siteAllocations", allocations),
      SiteAllocationsName: selectedSiteAllocations,
      SiteAllocationsAtHomeId: getId("siteAllocationsAtHome", allocations),
      SiteAllocationsAtHomeName: selectediteAllocationsAtHome,
      SiteAllocationsFcrId: getId("siteAllocationsFcr", allocations),
      SiteAllocationsFcrName: formik.values.siteAllocationsFcr.name,
      TotalClientsByManagerId: getId("totalClientsByManager", totalClients),
      TotalClientsByManagerName: formik.values.totalClientsByManager.name,
      VerticalAttributeId: getId("verticalAttribute", verticalAttributes),
      VerticalAttributeName: formik.values.verticalAttribute.name,
      GeoAttributeId: getId("geoAttribute", geoAttributes),
      GeoAttributeName: formik.values.geoAttribute.name,
      HyperGrowthClientId: getId("hypergrowthClient", hyperGrowthClients),
      HyperGrowthClientName: formik.values.hypergrowthClient.name,
      BusinessSegmentId: getSegmentAttributeId(formik.values.segmentAttribute.name, segmentAttributes),
      BusinessSegmentName: formik.values.segmentAttribute.name,
      IsSubmitted: isSubmitted,
      TimeZoneId: getId("timezone", timezones),
      TimeZoneName: formik.values.timezone.name,
      ChannelTypeId: (formik.values.channeltype as DropdownData[]).map(c => c.code).join("|"),
      ChannelTypeName: channeltype,
      RequestedStartDate: reqStartDate,
      SupportGroupName: formik.values.supportGroups.name,
      ManagedBy: formik.values.managedBy,
      OpsVp: formik.values.opsVP,
    };

    cppRequest.push(request);
    let BASE_URL = process.env.REACT_APP_API_URI;
    let url = BASE_URL + SAVECPPREQUEST_URL;

    const res: any = await new Promise((resolve, reject) => {
      try {
        axios
          .postRequest(url, request)
          .then((res: any) => {
            setShowLoader(false);
            setSpinnerClassName("divSpinner");
            resolve(res);
          })
          .catch((err: any) => {
            setShowLoader(false);
            setSpinnerClassName("divSpinner");
            setissubmitsuccess(false);
            setissavesuccess(false);
            resolve(err);
          });
      } catch (error) {
        setShowLoader(false);
        setSpinnerClassName("divSpinner");
        setissubmitsuccess(false);
        setissavesuccess(false);
        reject(error);
      }
    });
    setShowLoader(false);
    setSpinnerClassName("divSpinner");
    scrollToTop();

    if (res.status == "Success") {
      setissubmitsuccess(true);
      setissavesuccess(true);
      setisreadonly(true);
    } else {
      setissubmitsuccess(false);
      setissavesuccess(false);
    }
  };

  const isFormFieldValid = (number: any) =>
    !!(formik.touched[number] && formik.errors[number]);

  const getFormErrorMessage = (number: any) => {
    return (
      isFormFieldValid(number) && (
        <div className="p-error text-start ms-1 pt-1">
          {formik.errors[number]}
        </div>
      )
    );
  };

  const handleLegalEntityChange = async (legalEntity: any) => {
    if (legalEntity?.value.name !== "") {
      let contractedByCountryResponse: any = await getContractedByCountry(legalEntity?.value.name);
      let name = contractedByCountryResponse?.name;
      setContractByCountry(name);
    }
  };

  const handleNewParentNeededChange = async (dropdownvalue: any) => {
    formik.values.parentTotalClients = "";
    if (dropdownvalue?.value.name === "Yes") {
      setIsNewParentNeeded("1");
    } else {
      setIsNewParentNeeded("0");
    }
  };

  const handleNewUltimateParentNeededChange = async (dropdownvalue: any) => {
    formik.values.parentTotalClientsHyperion = "";
    if (dropdownvalue?.value.name === "Yes") {
      setIsNewUltimateParentNeeded("1");
    } else {
      setIsNewUltimateParentNeeded("0");
    }
  };

  function prefillDigitalDropdowns() {
    var name = "None";
    var idx = getCode(name, allocations);
    formik.values.siteAllocations = {};
    formik.values.siteAllocations["name"] = name;
    formik.values.siteAllocations["code"] = idx;
    formik.values.countryAllocations = {};
    formik.values.countryAllocations["name"] = name;
    formik.values.countryAllocations["code"] = idx;
    formik.values.regionalAllocations = {};
    formik.values.regionalAllocations["name"] = name;
    formik.values.regionalAllocations["code"] = idx;
    formik.values.siteAllocationsAtHome = {};
    formik.values.siteAllocationsAtHome["name"] = name;
    formik.values.siteAllocationsAtHome["code"] = idx;
    formik.values.siteAllocationsFcr = {};
    formik.values.siteAllocationsFcr["name"] = name;
    formik.values.siteAllocationsFcr["code"] = idx;
    formik.values.countryAllocationsFcr = {};
    formik.values.countryAllocationsFcr["name"] = name;
    formik.values.countryAllocationsFcr["code"] = idx;
    idx = getCode(name, cmsCgsSegments);
    formik.values.cmsCgsAllocations = {};
    formik.values.cmsCgsAllocations["name"] = name;
    formik.values.cmsCgsAllocations["code"] = idx;
    idx = getCode(name, engageSegments);
    formik.values.engageSegmentAllocations = {};
    formik.values.engageSegmentAllocations["name"] = name;
    formik.values.engageSegmentAllocations["code"] = idx;
    idx = getCode(name, segments);
    formik.values.segmentAllocations = {};
    formik.values.segmentAllocations["name"] = name;
    formik.values.segmentAllocations["code"] = idx;
    idx = getCode(name, clientRollups);
    formik.values.alternateClientRollups1 = {};
    formik.values.alternateClientRollups1["name"] = name;
    formik.values.alternateClientRollups1["code"] = idx;
    formik.values.alternateClientRollups2 = {};
    formik.values.alternateClientRollups2["name"] = name;
    formik.values.alternateClientRollups2["code"] = idx;
    idx = getCode(name, hyperGrowthClients);
    formik.values.hypergrowthClient = {};
    formik.values.hypergrowthClient["name"] = name;
    formik.values.hypergrowthClient["code"] = idx;
  }

  function resetDropdowns() {
    formik.values.siteAllocations = "";
    formik.values.countryAllocations = "";
    formik.values.regionalAllocations = "";
    formik.values.siteAllocationsAtHome = "";
    formik.values.siteAllocationsFcr = "";
    formik.values.countryAllocationsFcr = "";
    formik.values.cmsCgsAllocations = "";
    formik.values.engageSegmentAllocations = "";
    formik.values.segmentAllocations = "";
    formik.values.alternateClientRollups1 = "";
    formik.values.alternateClientRollups2 = "";
    formik.values.hypergrowthClient = "";
  }

  const setvisibleforms = () => {
    setItems(props.mode === "View" ? ([
      {
        label: 'Client Naming',
        command: (event: any) => { setVisibleDiv1(true); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Client Rollups',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(true); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Attributes',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(true); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Allocations',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(true); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      }
    ]) : ([
      {
        label: 'Client Naming',
        command: (event: any) => { setVisibleDiv1(true); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Client Rollups',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(true); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Attributes',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(true); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Allocations',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(true); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Review',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      }
    ]));
  }

  const setaddlvisibleforms = () => {
    setItems(props.mode === "View" ? ([
      {
        label: 'Client Naming',
        command: (event: any) => { setVisibleDiv1(true); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Client Rollups',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(true); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Attributes',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(true); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Allocations',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(true); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'AskNow Business Service',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(true); setissave(false); setissubmit(false); }
      }
    ]) : ([
      {
        label: 'Client Naming',
        command: (event: any) => { setVisibleDiv1(true); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Client Rollups',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(true); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Attributes',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(true); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'Allocations',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(true); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      },
      {
        label: 'AskNow Business Service',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(true); setissave(false); setissubmit(false); }
      },
      {
        label: 'Review',
        command: (event: any) => { setVisibleDiv1(false); setVisibleDiv2(false); setVisibleDiv3(false); setVisibleDiv4(false); setVisibleDiv5(false); setissave(false); setissubmit(false); }
      }
    ]));
  }

  const handleSegmentChange = async (segment: any) => {
    if (segment?.value.name !== "") {
      let name = segment?.value.name;
      setSegmentName(name);
      formik.setFieldValue("managedBy", "");
      formik.setFieldValue("opsVP", "");
      formik.setFieldValue("supportGroups", { name: "", code: "" });
      if (name == "Percepta") {
        setaddlvisibleforms();
        setShowAllocations(false);
        setDivHeight("800px");
      } else if (name == "Digital") {
        setaddlvisibleforms();
        prefillDigitalDropdowns();
        setShowAllocations(true);
        setDivHeight("1280px");
        formik.values.managedBy = DEFAULT_MAIL;
        formik.values.opsVP = DEFAULT_MAIL;
        formik.values.supportGroups = {};
        formik.values.supportGroups["name"] = DRP_DEFAULT_NAME;
        formik.values.supportGroups["code"] = DRP_DEFAULT_CODE;
      } else if (name == "Engage") {
        setaddlvisibleforms();
        prefillDigitalDropdowns();
        setShowAllocations(true);
        setDivHeight("1280px");
        formik.values.engageSegmentAllocations = {};
        formik.values.engageSegmentAllocations["code"] = "engRec";
        formik.values.engageSegmentAllocations["name"] = "Engage Receiver";
      } else if (name == "Corporate/Other (Seg)") {
        setvisibleforms();
        setShowAllocations(true);
      } else if (name == "None") {
        setvisibleforms();
        resetDropdowns();
        let noneID = getCode("Unused No Segment", totalClients);
        formik.values.totalClientsByManager = {};
        formik.values.totalClientsByManager["code"] = "tcbm";
        formik.values.totalClientsByManager["name"] = "Unused No Segment";
        setShowAllocations(true);
        setDivHeight("1280px");
      } else {
        setvisibleforms();
        resetDropdowns();
        setShowAllocations(true);
        setDivHeight("1280px");
      }
    }
  };

  const onkeypress = (e: any) => {
    let key = e.key;
    const arr = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "-", "_", "+", "=", ";", ":", "'", '"', "<", ">", "/", "?", "|", "\\", "{", "}", "[", "]", "~", "`", " "];
    if (arr.includes(key)) {
      e.preventDefault();
      return false;
    } else {
      if (text !== "" && text.toString().trim().length < 4) {
        formik.values.number = text.toString().trim() + e.key;
        setText(text.toString().trim() + e.key);
      }
    }
  };

  const onPaste = (e: any) => {
    e.preventDefault();
  };

  const onblur = (e: any) => {
    if (formik.values.number !== "" || !props.showHeader) {
      validateClientCode(formik.values.number, props.showHeader ? 0 : props.requestDetails["id"]);
    }
    if (formik.values.number === "" || !props.showHeader) {
      toast.current.show({ severity: "error", summary: "Error", detail: "Please enter a Requested Number", life: 3000 });
    }
  };

  const onopsvpblur = (e: any) => {
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(e.target.value)) {
        toast.current.show({ severity: "success", summary: "Success", detail: "Valid Email Address", life: 3000 });
      } else {
        opsvpRef.current.focus();
        toast.current.show({ severity: "warn", summary: "Warn", detail: "Please Enter Valid Email Address", life: 3000 });
      }
    }
  }

  const onmanagedbyblur = (e: any) => {
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(e.target.value)) {
        toast.current.show({ severity: "success", summary: "Success", detail: "Valid Email Address", life: 3000 });
      } else {
        managedbyRef.current.focus();
        toast.current.show({ severity: "warn", summary: "Warn", detail: "Please Enter Valid Email Address", life: 3000 });
      }
    }
  }

  const onclientnameblur = (e: any) => {
    if (formik.values.clientReportingAliasName !== "" || !props.showHeader) {
      if (hasDisallowedNameCharacters(formik.values.clientReportingAliasName)) {
        console.log("hit");
        clientnameRef.current.focus();
        toast.current.show({ severity: "warn", summary: "Warn", detail: buildDisallowedNameCharsMessage(formik.values.clientReportingAliasName), life: 3000 });
        return;
      }
      validateClientName(formik.values.clientReportingAliasName, props.showHeader ? 0 : props.requestDetails["id"]);
    }
    if (formik.values.number === "" || !props.showHeader) {
      toast.current.show({ severity: "error", summary: "Error", detail: "Please enter a Requested Number", life: 3000 });
    }
  };

  const onParentClientBlur = (e: any) => {
    if (formik.values.parentTotalClients !== "" || !props.showHeader) {
      validateparentandultimateclient(formik.values.parentTotalClients, "p", props.showHeader ? 0 : props.requestDetails["id"]);
    }
  };

  const onUltimateParentClientBlur = (e: any) => {
    if (formik.values.parentTotalClientsHyperion !== "" || !props.showHeader) {
      if (isNewUltimateParentNeeded === "1") {
        validateparentandultimateclient(formik.values.parentTotalClientsHyperion, "u", props.showHeader ? 0 : props.requestDetails["id"]);
      }
    }
  };

  const validateClientCode = async (reqnum: any, id: any) => {
    let url = BASE_URL + ValidateClientCode_URL;
    const res: any = await new Promise((resolve, reject) => {
      try {
        setShowLoader(true);
        axios.getRequest(url + "?reqnum=" + reqnum + "&id=" + id)
          .then((res: any) => { setShowLoader(false); hideLoader(); resolve(res); })
          .catch((err: any) => { setShowLoader(false); hideLoader(); resolve(err); });
      } catch (error) {
        setShowLoader(false);
        hideLoader();
        reject(error);
      }
    });

    if (res.statusCode === 200 && res.isValid) {
      toast.current.show({ severity: "success", summary: "Success", detail: "Valid Requested Number", life: 3000 });
    } else if (res.statusCode === 200 && !res.isValid) {
      nameRef.current.focus();
      toast.current.show({ severity: "warn", summary: "Warn", detail: "Requested Number already exists", life: 3000 });
    } else {
      toast.current.show({ severity: "error", summary: "Error", detail: "Error checking for valid Requested Number", life: 3000 });
    }
  };

  const validateClientName = async (name: any, id: any) => {
    let url = BASE_URL + ValidateClientName_URL;
    const res: any = await new Promise((resolve, reject) => {
      try {
        setShowLoader(true);
        axios.getRequest(url + "?name=" + name + "&id=" + id)
          .then((res: any) => { setShowLoader(false); hideLoader(); resolve(res); })
          .catch((err: any) => { setShowLoader(false); hideLoader(); resolve(err); });
      } catch (error) {
        setShowLoader(false);
        hideLoader();
        reject(error);
      }
    });

    if (res.statusCode === 200 && res.isValid) {
      toast.current.show({ severity: "success", summary: "Success", detail: "Valid Client Name", life: 3000 });
    } else if (res.statusCode === 200 && !res.isValid) {
      clientnameRef.current.focus();
      toast.current.show({ severity: "warn", summary: "Warn", detail: "Client Name already exists", life: 3000 });
    } else {
      toast.current.show({ severity: "error", summary: "Error", detail: "Error checking for valid Client Name", life: 3000 });
    }
  };

  const validateparentandultimateclient = async (name: any, clienttype: any, id: any) => {
    let url = BASE_URL + ValidateParentandUltimateClient_URL;
    const res: any = await new Promise((resolve, reject) => {
      try {
        setShowLoader(true);
        axios.getRequest(url + "?name=" + name + "&clienttype=" + clienttype + "&id=" + id)
          .then((res: any) => { setShowLoader(false); hideLoader(); resolve(res); })
          .catch((err: any) => { setShowLoader(false); hideLoader(); resolve(err); });
      } catch (error) {
        setShowLoader(false);
        hideLoader();
        reject(error);
      }
    });

    if (res.statusCode === 200 && res.isValid) {
      toast.current.show({ severity: "success", summary: "Success", detail: clienttype === "p" ? "Valid Parent Client" : "Valid Ultimate Parent Client", life: 3000 });
    } else if (res.statusCode === 200 && !res.isValid) {
      if (clienttype === "p") {
        parentClientRef.current.focus();
        toast.current.show({ severity: "warn", summary: "Warn", detail: "Parent Client already exists", life: 3000 });
      } else {
        ultimateClientRef.current.focus();
        toast.current.show({ severity: "warn", summary: "Warn", detail: "Ultimate Parent Client already exists", life: 3000 });
      }
    } else {
      toast.current.show({ severity: "error", summary: "Error", detail: clienttype === "p" ? "Error checking for valid parent client" : "Error checking for valid ultimate parent client", life: 3000 });
    }
  };

  const clientheader = () => {
    return (<h4 className="clsheader">Create a Client</h4>);
  }

  const clientdetailsheader = () => {
    return (<h4 className="clsheader">Client Configuration Details</h4>);
  }

  return (
    <>
      {props.requestDetails ? <div></div> : <div className="row m-2 mt-4"><NavLink to={NEWCPPREQUEST}><h4>{'< Back to Creation Menu'}</h4></NavLink></div>}
      <form onSubmit={formik.handleSubmit} className="p-fluid">
        <div className="divCard">
          <Card className="clscard col-md-8 mt-4" header={clientheader}>
            <div className="row m-3 mt-4">
              <div className="divsteps col-md-12 m-1">
                <Steps model={items} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={isreadonly} />
              </div>
              <div className="col-md-4 clientimg"><img src={img} className="clsimg" /></div>
              <div className="col-md-8">
                <Toast ref={toast} />
                <Tooltip id="requested-number-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="default-alias-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="client-reporting-alias-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="new-parent-eig-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="parent-total-clients-eig-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="new-parent-hyperion-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="parent-total-clients-hyperion-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="segment-attribute-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="receiver-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />
                <Tooltip id="blank-tooltip" style={{ backgroundColor: "#BBEBF5", color: "#222" }} />

                <div className="client-naming-form">
                  <div className="d-flex flex-column flex-shrink-0 p-3 w-100">

                    {isVisibleDiv1 ? (
                      <div className="divscroll">
                        <div className="label-bold">Client Naming</div>
                        <div className="clscol m-2">
                          <span>
                            <label id="lbl" htmlFor="number" className={classNames({ "p-error": isFormFieldValid("number") })}>Requested Number*</label>
                            <InputText id="number" name="number" type="text" maxLength={4} data-tooltip-id="requested-number-tooltip" data-tooltip-content="Client Code" placeholder="Enter Requested Number" onChange={formik.handleChange} onKeyPress={(e: any) => onkeypress(e)} onPaste={(e: any) => onPaste(e)} onBlur={(e: any) => onblur(e)} value={formik.values.number} disabled={props.mode === "View"} className={classNames({ "p-invalid": isFormFieldValid("number") })} ref={nameRef} />
                            {getFormErrorMessage("number")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span>
                            <label id="lbl" htmlFor="clientReportingAliasName" className={classNames({ "p-error": isFormFieldValid("clientReportingAliasName") })}>Client Reporting Alias Name*</label>
                            <InputText id="clientReportingAliasName" name="clientReportingAliasName" maxLength={50} data-tooltip-id="client-reporting-alias-tooltip" data-tooltip-content="Client Name" value={formik.values.clientReportingAliasName} disabled={props.mode === "View"} placeholder="Enter Client Reporting Alias Name" onChange={formik.handleChange} onBlur={(e: any) => onclientnameblur(e)} onPaste={(e: any) => onPaste(e)} className={classNames({ "p-invalid": isFormFieldValid("clientReportingAliasName") })} ref={clientnameRef} />
                            {getFormErrorMessage("clientReportingAliasName")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span>
                            <label id="lbl" htmlFor="defaultAliasName" className={classNames({ "p-error": isFormFieldValid("defaultAliasName") })}>Default Alias Name*</label>
                            <InputText id="defaultAliasName" name="defaultAliasName" data-tooltip-id="default-alias-tooltip" data-tooltip-content="Client Code 'space' Client Name" value={formik.values.number + " " + formik.values.clientReportingAliasName} placeholder="Enter Default Alias Name" onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("defaultAliasName") })} disabled />
                            {getFormErrorMessage("defaultAliasName")}
                          </span>
                        </div>
                      </div>
                    ) : ""}

                    {isVisibleDiv2 ? (
                      <div className="divscroll">
                        <div className="label-bold">Client Rollups</div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="segmentAttributeAlloc" className={classNames({ "p-error": isFormFieldValid("segmentAttributeAlloc") })}>Segment*</label>
                            <Dropdown id="segmentAttributeAlloc" name="segmentAttributeAlloc" filter value={formik.values.segmentAttributeAlloc} disabled={props.mode === "View"} onChange={(value) => { handleSegmentChange(value); formik.handleChange(value); }} options={segments} className={classNames({ "p-invalid": isFormFieldValid("segmentAttributeAlloc") })} optionLabel="name" />
                            {getFormErrorMessage("segmentAttributeAlloc")}
                            <span className="instruction">*If segment is Percepta, no allocation identification required</span>
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="clientType" className={classNames({ "p-error": isFormFieldValid("clientType") })}>Select Client Type *</label>
                            <Dropdown id="clientType" name="clientType" filter value={formik.values.clientType} disabled={props.mode === "View"} onChange={formik.handleChange} options={clientTypes} className={classNames({ "p-invalid": isFormFieldValid("clientType") })} optionLabel="name" />
                            {getFormErrorMessage("clientType")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="newParentNeeded" className={classNames({ "p-error": isFormFieldValid("newParentNeeded") })}>Select New Parent Needed (EIG)*</label>
                            <Dropdown id="newParentNeeded" name="newParentNeeded" filter data-tooltip-id="new-parent-eig-tooltip" data-tooltip-content="Is this a current TTEC Client?" value={formik.values.newParentNeeded} disabled={props.mode === "View"} onChange={(value: any) => { handleNewParentNeededChange(value); formik.handleChange(value); }} options={newParentNeededOptions} className={classNames({ "p-invalid": isFormFieldValid("newParentNeeded") })} optionLabel="name" />
                            {getFormErrorMessage("newParentNeeded")}
                          </span>
                        </div>
                        {(isNewParentNeeded === "1" || isNewParentNeeded === "0") && (
                          <div className="clscol m-2">
                            <span>
                              <label id="lbl" htmlFor="parentTotalClients" className={classNames({ "p-error": isFormFieldValid("parentTotalClients") })}>Parent in Total Clients (EIG)*</label>
                              {isNewParentNeeded === "1" && (
                                <InputText id="parentTotalClients" placeholder="Enter Parent in Total Clients  (EIG)" name="parentTotalClients" maxLength={100} data-tooltip-id="parent-total-clients-eig-tooltip" data-tooltip-content="If Yes, write name of new client.  If No, write name of existing client." value={formik.values.parentTotalClients} disabled={props.mode === "View"} onChange={formik.handleChange} onBlur={(e: any) => onParentClientBlur(e)} className={classNames({ "p-invalid": isFormFieldValid("parentTotalClients") })} ref={parentClientRef} />
                              )}
                              {isNewParentNeeded === "0" && (
                                <Dropdown id="parentTotalClients" name="parentTotalClients" filter data-tooltip-id="parent-total-clients-eig-tooltip" data-tooltip-content="If Yes, write name of new client.  If No, write name of existing client." value={formik.values.parentTotalClients} disabled={props.mode === "View"} onChange={(value: any) => {
                                  formik.handleChange(value);
                                  if (value.value?.name) {
                                    getParentClientStartDate(value.value.name).then((res: any) => {
                                      setParentClientStartDate(res?.startdate ? new Date(res.startdate) : null);
                                    });
                                  }
                                }} options={parentClientResponse} className={classNames({ "p-invalid": isFormFieldValid("parentTotalClients") })} optionLabel="name" />
                              )}
                              {getFormErrorMessage("parentTotalClients")}
                            </span>
                          </div>
                        )}
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="newParentNeededHyperion" className={classNames({ "p-error": isFormFieldValid("newParentNeededHyperion") })}>Select New Parent Needed (Hyperion)*</label>
                            <Dropdown id="newParentNeededHyperion" name="newParentNeededHyperion" filter data-tooltip-id="new-parent-hyperion-tooltip" data-tooltip-content="Confirm in Total Client heirarchy if parent exists.  If it does, select 'No', if not select 'Yes'." value={formik.values.newParentNeededHyperion} disabled={props.mode === "View"} onChange={(value: any) => { handleNewUltimateParentNeededChange(value); formik.handleChange(value); }} options={newParentNeededOptions} className={classNames({ "p-invalid": isFormFieldValid("newParentNeededHyperion") })} optionLabel="name" />
                            {getFormErrorMessage("newParentNeededHyperion")}
                          </span>
                        </div>
                        {(isNewUltimateParentNeeded === "1" || isNewUltimateParentNeeded === "0") && (
                          <div className="clscol m-2">
                            <span>
                              <label id="lbl" htmlFor="parentTotalClientsHyperion" className={classNames({ "p-error": isFormFieldValid("parentTotalClientsHyperion") })}>Parent in Total Clients (Hyperion)*</label>
                              {isNewUltimateParentNeeded === "1" && (
                                <InputText id="parentTotalClientsHyperion" placeholder="Enter Parent in Total Clients (Hyperion)" data-tooltip-id="parent-total-clients-hyperion-tooltip" data-tooltip-content="If Yes, write new client name.  If No, select 'external clients'." name="parentTotalClientsHyperion" maxLength={100} value={formik.values.parentTotalClientsHyperion} disabled={props.mode === "View"} onChange={formik.handleChange} onBlur={(e: any) => onUltimateParentClientBlur(e)} className={classNames({ "p-invalid": isFormFieldValid("parentTotalClientsHyperion") })} ref={ultimateClientRef} />
                              )}
                              {isNewUltimateParentNeeded === "0" && (
                                <Dropdown id="parentTotalClientsHyperion" name="parentTotalClientsHyperion" filter data-tooltip-id="parent-total-clients-hyperion-tooltip" data-tooltip-content="If Yes, write new client name.  If No, select 'external clients'." value={formik.values.parentTotalClientsHyperion} disabled={props.mode === "View"} onChange={(value: any) => { formik.handleChange(value); }} options={ultimateParentResponse} className={classNames({ "p-invalid": isFormFieldValid("parentTotalClientsHyperion") })} optionLabel="name" />
                              )}
                              {getFormErrorMessage("parentTotalClientsHyperion")}
                            </span>
                          </div>
                        )}
                        <div className="label-bold">State the Direct Parent in these client hierarchies</div>
                        <div className="clscol m-2">
                          <span>
                            <label id="lbl" htmlFor="totalClientsByManager" className={classNames({ "p-error": isFormFieldValid("totalClientsByManager") })}>Total Clients - By Manager*</label>
                            <Dropdown id="totalClientsByManager" name="totalClientsByManager" filter value={formik.values.totalClientsByManager} disabled={props.mode === "View"} onChange={(value) => { formik.handleChange(value); }} options={totalClients} className={classNames({ "p-invalid": isFormFieldValid("totalClientsByManager") })} optionLabel="name" />
                            {getFormErrorMessage("totalClientsByManager")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="legalEntity" className={classNames({ "p-error": isFormFieldValid("legalEntity") })}>Select Contracting Entity*</label>
                            <Dropdown id="legalEntity" name="legalEntity" filter value={formik.values.legalEntity} disabled={props.mode === "View"} onChange={(value) => { handleLegalEntityChange(value); formik.handleChange(value); }} options={legalEntities} className={classNames({ "p-invalid": isFormFieldValid("legalEntity") })} optionLabel="name" />
                            {getFormErrorMessage("legalEntity")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span>
                            <label id="lbl" htmlFor="contractByCountry" className={classNames({ "p-error": isFormFieldValid("contractByCountry") })}>Total Clients - Contracted by Country*</label>
                            <InputText id="contractByCountry" readOnly name="contractByCountry" value={contractByCountry} disabled={props.mode === "View"} maxLength={100} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("contractByCountry") })} />
                            {getFormErrorMessage("contractByCountry")}
                          </span>
                        </div>
                      </div>
                    ) : ""}

                    {isVisibleDiv3 ? (
                      <div className="divscroll">
                        <div className="label-bold">Attributes</div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="segmentAttribute" className={classNames({ "p-error": isFormFieldValid("segmentAttribute") })}>Segment Attribute*</label>
                            <Dropdown id="segmentAttribute" name="segmentAttribute" filter data-tooltip-id="segment-attribute-tooltip" data-tooltip-content="If unknown, contact your Finance partner." value={formik.values.segmentAttribute} disabled={props.mode === "View"} onChange={formik.handleChange} options={segmentAttributes} className={classNames({ "p-invalid": isFormFieldValid("segmentAttribute") })} optionLabel="name" />
                            {getFormErrorMessage("segmentAttribute")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="verticalAttribute" className={classNames({ "p-error": isFormFieldValid("verticalAttribute") })}>Vertical Attribute*</label>
                            <Dropdown id="verticalAttribute" name="verticalAttribute" filter value={formik.values.verticalAttribute} disabled={props.mode === "View"} onChange={formik.handleChange} options={verticalAttributes} className={classNames({ "p-invalid": isFormFieldValid("verticalAttribute") })} optionLabel="name" />
                            {getFormErrorMessage("verticalAttribute")}
                          </span>
                        </div>
                        {!showHeader ? <div>{" "}</div> : ""}
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="geoAttribute" className={classNames({ "p-error": isFormFieldValid("geoAttribute") })}>Geo Attribute*</label>
                            <Dropdown id="geoAttribute" name="geoAttribute" filter value={formik.values.geoAttribute} disabled={props.mode === "View"} onChange={formik.handleChange} options={geoAttributes} className={classNames({ "p-invalid": isFormFieldValid("geoAttribute") })} optionLabel="name" />
                            {getFormErrorMessage("geoAttribute")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="clientPortfolio" className={classNames({ "p-error": isFormFieldValid("clientPortfolio") })}>Client Portfolio*</label>
                            <Dropdown id="clientPortfolio" name="clientPortfolio" filter value={formik.values.clientPortfolio} disabled={props.mode === "View"} onChange={formik.handleChange} options={clientPortfolio} className={classNames({ "p-invalid": isFormFieldValid("clientPortfolio") })} optionLabel="name" />
                            {getFormErrorMessage("clientPortfolio")}
                          </span>
                        </div>
                        <div className="label-bold">Other Client Details</div>
                        <div className="clscol m-2">
                          <label id="lbl" htmlFor="alternateClientRollups1" className={classNames({ "p-error": isFormFieldValid("alternateClientRollups1") })}>Alternate Client Rollups #1</label>
                          <span className="selectList">
                            <Dropdown id="alternateClientRollups1" name="alternateClientRollups1" filter value={formik.values.alternateClientRollups1} disabled={props.mode === "View"} onChange={formik.handleChange} options={clientRollups} data-tooltip-id="blank-tooltip" data-tooltip-content="Leave blank" optionLabel="name" />
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <label id="lbl" htmlFor="alternateClientRollups2" className={classNames({ "p-error": isFormFieldValid("alternateClientRollups2") })}>Alternate Client Rollups #2</label>
                          <span className="selectList">
                            <Dropdown id="alternateClientRollups2" name="alternateClientRollups2" filter value={formik.values.alternateClientRollups2} disabled={props.mode === "View"} onChange={formik.handleChange} options={clientRollups} data-tooltip-id="blank-tooltip" data-tooltip-content="Leave blank" optionLabel="name" />
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <label id="lbl" htmlFor="hypergrowthClient" className={classNames({ "p-error": isFormFieldValid("hypergrowthClient") })}>Hypergrowth Client</label>
                          <span className="selectList">
                            <Dropdown id="hypergrowthClient" name="hypergrowthClient" filter value={formik.values.hypergrowthClient} disabled={props.mode === "View"} onChange={formik.handleChange} options={hyperGrowthClients} defaultValue="None" data-tooltip-id="blank-tooltip" data-tooltip-content="Leave blank" optionLabel="name" />
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="timezone" className={classNames({ "p-error": isFormFieldValid("timezone") })}>Timezone*</label>
                            <Dropdown id="timezone" name="timezone" filter value={formik.values.timezone} disabled={props.mode === "View"} onChange={formik.handleChange} options={timezones} className={classNames({ "p-invalid": isFormFieldValid("timezone") })} optionLabel="name" />
                            {getFormErrorMessage("timezone")}
                          </span>
                        </div>

                        {/* Custom Channel Multiselect Dropdown */}
                        <div className="clscol m-2">
                          <label id="lbl" htmlFor="channeltype">Channel</label>
                          <div ref={channelDropdownRef} style={{ position: "relative", width: "100%" }}>
                            <div
                              onClick={() => props.mode !== "View" && setChannelDropdownOpen(!channelDropdownOpen)}
                              style={{
                                border: "1px solid #ced4da",
                                borderRadius: "4px",
                                padding: "8px 12px",
                                cursor: props.mode === "View" ? "default" : "pointer",
                                background: props.mode === "View" ? "#f8f9fa" : "#fff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                minHeight: "42px"
                              }}
                            >
                              <span style={{ fontSize: "14px", color: (formik.values.channeltype as DropdownData[]).length === 0 ? "#aaa" : "#000" }}>
                                {(formik.values.channeltype as DropdownData[]).length === 0
                                  ? "Select Channel(s)"
                                  : (formik.values.channeltype as DropdownData[]).length <= 2
                                    ? (formik.values.channeltype as DropdownData[]).map(c => c.name).join(", ")
                                    : `${(formik.values.channeltype as DropdownData[]).length} channels selected`}
                              </span>
                              <i className="pi pi-chevron-down" style={{ fontSize: "12px", color: "#666" }} />
                            </div>
                            {channelDropdownOpen && (
                              <div style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                background: "#fff",
                                border: "1px solid #ced4da",
                                borderRadius: "4px",
                                zIndex: 9999,
                                maxHeight: "200px",
                                overflowY: "auto",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                              }}>
                                {channelTypes.map((channel: DropdownData) => {
                                  const selected = (formik.values.channeltype as DropdownData[]).some(c => c.code === channel.code);
                                  return (
                                    <div
                                      key={channel.code}
                                      onClick={() => {
                                        const current = formik.values.channeltype as DropdownData[];
                                        const updated = selected
                                          ? current.filter(c => c.code !== channel.code)
                                          : [...current, channel];
                                        formik.setFieldValue("channeltype", updated);
                                      }}
                                      style={{
                                        padding: "8px 12px",
                                        cursor: "pointer",
                                        background: selected ? "#e8f4ff" : "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        fontSize: "14px",
                                        borderBottom: "1px solid #f0f0f0"
                                      }}
                                    >
                                      <input type="checkbox" readOnly checked={selected} style={{ cursor: "pointer", accentColor: "#3299FF" }} />
                                      {channel.name}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="clscol m-2">
                          <span>
                            <label id="lbl" htmlFor="requestedStartDate" className={classNames({ "p-error": isFormFieldValid("requestedStartDate") })}>Requested Start Date (MM/DD/YYYY)</label>
                            <Calendar
                              className="psd-calendar"
                              placeholder="mm/dd/yyyy"
                              name="requestedStartDate"
                              value={formik.values.requestedStartDate}
                              disabled={props.mode === "View"}
                              onChange={(e: any) => {
                                formik.handleChange(e);
                                if (e.value && parentClientStartDate && e.value < parentClientStartDate) {
                                  toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: `Requested Start Date cannot be earlier than parent client start date (${parentClientStartDate.toLocaleDateString()})`,
                                    life: 5000
                                  });
                                  formik.setFieldValue("requestedStartDate", "");
                                }
                              }}
                              showIcon
                            />                            {getFormErrorMessage("requestedStartDate")}
                          </span>
                        </div>
                      </div>
                    ) : ""}

                    {isVisibleDiv4 ? (
                      <div className="divscroll">
                        <div className="label-bold">Allocations</div>
                        <div className="label-bold">Corporate Allocations</div>
                        <div className="clscol m-2">
                          <label id="lbl" htmlFor="corpAllocations" className={classNames({ "p-error": isFormFieldValid("corpAllocations") })}>Corp Allocations*</label>
                          <span className="selectList">
                            <Dropdown id="corpAllocations" name="corpAllocations" filter data-tooltip-id="receiver-tooltip" data-tooltip-content=" Select 'Receiver'" value={formik.values.corpAllocations} disabled={props.mode === "View"} onChange={formik.handleChange} options={allocations} className={classNames({ "p-invalid": isFormFieldValid("corpAllocations") })} optionLabel="name" />
                            {getFormErrorMessage("corpAllocations")}
                          </span>
                        </div>
                        {showAllocations && (
                          <>
                            <div className="label-bold">Engage Allocations</div>
                            <div className="clscol m-2">
                              <span className="selectList">
                                <label id="lbl" htmlFor="siteAllocations" className={classNames({ "p-error": isFormFieldValid("siteAllocations") })}>Site Allocations*</label>
                                <Dropdown id="siteAllocations" name="siteAllocations" filter value={formik.values.siteAllocations} disabled={props.mode === "View"} onChange={formik.handleChange} options={allocations} data-tooltip-id="receiver-tooltip" data-tooltip-content=" Select 'Receiver'" className={classNames({ "p-invalid": isFormFieldValid("siteAllocations") })} optionLabel="name" />
                                {getFormErrorMessage("siteAllocations")}
                              </span>
                            </div>
                            <div className="clscol m-2">
                              <span className="selectList">
                                <label id="lbl" htmlFor="countryAllocations" className={classNames({ "p-error": isFormFieldValid("countryAllocations") })}>Country Allocations*</label>
                                <Dropdown id="countryAllocations" name="countryAllocations" filter value={formik.values.countryAllocations} disabled={props.mode === "View"} onChange={formik.handleChange} options={allocations} data-tooltip-id="receiver-tooltip" data-tooltip-content=" Select 'Receiver'" className={classNames({ "p-invalid": isFormFieldValid("countryAllocations") })} optionLabel="name" />
                                {getFormErrorMessage("countryAllocations")}
                              </span>
                            </div>
                            <div className="clscol m-2">
                              <label id="lbl" htmlFor="regionalAllocations" className={classNames({ "p-error": isFormFieldValid("regionalAllocations") })}>Regional Allocations*</label>
                              <span className="selectList">
                                <Dropdown id="regionalAllocations" name="regionalAllocations" filter value={formik.values.regionalAllocations} disabled={props.mode === "View"} onChange={formik.handleChange} options={allocations} data-tooltip-id="receiver-tooltip" data-tooltip-content=" Select 'Receiver'" className={classNames({ "p-invalid": isFormFieldValid("regionalAllocations") })} optionLabel="name" />
                                {getFormErrorMessage("regionalAllocations")}
                              </span>
                            </div>
                            <div className='clscol m-2'>
                              <label id="lbl" htmlFor="cmsCgsAllocations" className={classNames({ "p-error": isFormFieldValid("cmsCgsAllocations") })}>CMS/CGS Allocations*</label>
                              <span className="selectList">
                                <Dropdown id="cmsCgsAllocations" name="cmsCgsAllocations" filter value={formik.values.cmsCgsAllocations} disabled={props.mode === "View"} onChange={formik.handleChange} options={cmsCgsSegments} className={classNames({ "p-invalid": isFormFieldValid("cmsCgsAllocations") })} optionLabel="name" />
                                {getFormErrorMessage("cmsCgsAllocations")}
                              </span>
                            </div>
                            <div className='clscol m-2'>
                              <label id="lbl" htmlFor="engageSegmentAllocations" className={classNames({ "p-error": isFormFieldValid("engageSegmentAllocations") })}>Engage Segment Allocations*</label>
                              <span className="selectList">
                                <Dropdown id="engageSegmentAllocations" name="engageSegmentAllocations" filter value={formik.values.engageSegmentAllocations} disabled={props.mode === "View"} onChange={formik.handleChange} options={engageSegments} className={classNames({ "p-invalid": isFormFieldValid("engageSegmentAllocations") })} optionLabel="name" />
                                {getFormErrorMessage("engageSegmentAllocations")}
                              </span>
                            </div>
                            <div className="label-bold">At Home Allocations</div>
                            <div className="clscol m-2">
                              <span className="selectList">
                                <label id="lbl" htmlFor="siteAllocationsAtHome" className={classNames({ "p-error": isFormFieldValid("siteAllocationsAtHome") })}>Site Allocations</label>
                                <Dropdown id="siteAllocationsAtHome" name="siteAllocationsAtHome" filter value={formik.values.siteAllocationsAtHome} disabled={props.mode === "View"} onChange={formik.handleChange} options={allocations} data-tooltip-id="blank-tooltip" data-tooltip-content="Leave blank" optionLabel="name" />
                              </span>
                            </div>
                            <div className="clscol m-2">
                              <label id="lbl" htmlFor="segmentAllocations" className={classNames({ "p-error": isFormFieldValid("segmentAllocations") })}>Segment Allocations</label>
                              <span className="selectList">
                                <Dropdown id="segmentAllocations" name="segmentAllocations" filter value={formik.values.segmentAllocations} disabled={props.mode === "View"} onChange={formik.handleChange} options={segments} data-tooltip-id="blank-tooltip" data-tooltip-content="Leave blank" optionLabel="name" />
                              </span>
                            </div>
                            {" "}
                          </>
                        )}
                        <div className="label-bold">FCR Allocations</div>
                        <div className="clscol m-2">
                          <label id="lbl" htmlFor="siteAllocationsFcr" className={classNames({ "p-error": isFormFieldValid("siteAllocationsFcr") })}>Site Allocations*</label>
                          <span className="selectList">
                            <Dropdown id="siteAllocationsFcr" name="siteAllocationsFcr" filter value={formik.values.siteAllocationsFcr} disabled={props.mode === "View"} onChange={formik.handleChange} options={allocations} className={classNames({ "p-invalid": isFormFieldValid("siteAllocationsFcr") })} optionLabel="name" />
                            {getFormErrorMessage("siteAllocationsFcr")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <label id="lbl" htmlFor="countryAllocationsFcr" className={classNames({ "p-error": isFormFieldValid("countryAllocationsFcr") })}>Country Allocations*</label>
                          <span className="selectList">
                            <Dropdown id="countryAllocationsFcr" name="countryAllocationsFcr" filter value={formik.values.countryAllocationsFcr} disabled={props.mode === "View"} onChange={formik.handleChange} options={allocations} className={classNames({ "p-invalid": isFormFieldValid("countryAllocationsFcr") })} optionLabel="name" />
                            {getFormErrorMessage("countryAllocationsFcr")}
                          </span>
                        </div>
                      </div>
                    ) : ""}

                    {isVisibleDiv5 ? (
                      <div className="divscroll">
                        <div className="label-bold">AskNow Business Service</div>
                        <div className="clscol m-2">
                          <span>
                            <label id="lbl" htmlFor="managedBy" className={classNames({ "p-error": isFormFieldValid("managedBy") })}>Managed By*</label>
                            <InputText id="managedBy" name="managedBy" type="text" placeholder="Enter Email Address" onChange={formik.handleChange} value={formik.values.managedBy} disabled={props.mode === "View"} onBlur={(e: any) => onmanagedbyblur(e)} className={classNames({ "p-invalid": isFormFieldValid("managedBy") })} ref={managedbyRef} />
                            {getFormErrorMessage("managedBy")}
                            <span className="instruction">*This is the IT PM or TAM or whoever will be the RFC approver</span>
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl" htmlFor="supportGroups" className={classNames({ "p-error": isFormFieldValid("supportGroups") })}>Support Group*</label>
                            <Dropdown id="supportGroups" name="supportGroups" filter onChange={formik.handleChange} value={formik.values.supportGroups} disabled={props.mode === "View"} options={supportgroups} className={classNames({ "p-invalid": isFormFieldValid("supportGroups") })} optionLabel="name" />
                            {getFormErrorMessage("supportGroups")}
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span>
                            <label id="lbl" htmlFor="opsVP" className={classNames({ "p-error": isFormFieldValid("opsVP") })}>Ops VP*</label>
                            <InputText id="opsVP" name="opsVP" type="email" onChange={formik.handleChange} value={formik.values.opsVP} disabled={props.mode === "View"} placeholder="Enter Email Address" onBlur={(e: any) => onopsvpblur(e)} className={classNames({ "p-invalid": isFormFieldValid("opsVP") })} ref={opsvpRef} />
                            {getFormErrorMessage("opsVP")}
                          </span>
                        </div>
                        <div></div>
                      </div>
                    ) : ""}

                    {(!isVisibleDiv1 && !isVisibleDiv2 && !isVisibleDiv3 && !isVisibleDiv4 && !isVisibleDiv5) &&
                      <div className="clsreview">
                        {((!issubmit && !issave) && ((segmentname !== "Engage" && segmentname !== "Percepta" && segmentname !== "Digital" && activeIndex === 4) || ((segmentname === "Engage" || segmentname === "Percepta" || segmentname === "Digital") && activeIndex == 5))) &&
                          <><h2 className="clstext"><b>Client Review</b></h2><h6 className="clstext">Please review all client details before saving or submiting</h6></>
                        }
                        {(!showLoader && ((issave && issavesuccess) || (issubmit && issubmitsuccess))) &&
                          <><h2 className="clstext"><b>Congratulations!</b></h2><h6 className="clstext">{issave ? "You've successfully saved a new client" : "You've successfully submitted a new client"}</h6></>
                        }
                        {(!showLoader && ((issave && !issavesuccess) || (issubmit && !issubmitsuccess))) &&
                          <><h2 className="clstext"><b>Something went wrong.</b></h2><h6 className="clstext">{issave ? "Error while saving a new client.Please try again" : "Error while submitting a new client.Please try again"}</h6></>
                        }
                        {(showLoader) &&
                          <><h2 className="clstext"><b>Pleast wait!</b></h2><h6 className="clstext">Processing your request</h6></>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <Card className="clscard col-md-4 mt-4" header={clientdetailsheader}>
            <div className="clscontent">
              {(formik.values.number !== "" || formik.values.clientReportingAliasName !== "") &&
                <Card className="m-2">
                  <table className="tbleven clstable">
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>Client Naming</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr"><td className="clstd">Requested Number*</td><td className="clstd">{formik.values.number}</td></tr>
                      <tr className="clstr"><td className="clstd">Client Reporting Alias Name*</td><td className="clstd">{formik.values.clientReportingAliasName}</td></tr>
                      <tr className="clstr"><td className="clstd">Default Alias Name*</td><td className="clstd">{formik.values.number + " " + formik.values.clientReportingAliasName}</td></tr>
                    </tbody>
                  </table>
                </Card>}
              {(formik.values.segmentAttributeAlloc.name !== "" || formik.values.clientType.name !== "" || formik.values.newParentNeeded.name !== "" || formik.values.newParentNeededHyperion.name !== "" || formik.values.totalClientsByManager.name !== "" || formik.values.legalEntity.name !== "" || (isNewParentNeeded === "1" && formik.values.parentTotalClients !== "") || (isNewParentNeeded === "0" && formik.values.parentTotalClients.name !== "") || (isNewUltimateParentNeeded === "1" && formik.values.parentTotalClientsHyperion !== "") || (isNewUltimateParentNeeded === "0" && formik.values.parentTotalClientsHyperion.name !== "")) &&
                <Card className="m-2">
                  <table className="tblodd clstable">
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>Client Rollups</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr"><td className="clstd">Segment*</td><td className="clstd">{formik.values.segmentAttributeAlloc.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Select Client Type*</td><td className="clstd">{formik.values.clientType.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Select New Parent Needed (EIG)*</td><td className="clstd">{formik.values.newParentNeeded.name}</td></tr>
                      {(isNewParentNeeded === "1" || isNewParentNeeded === "0") && <tr className="clstr"><td className="clstd">Parent in Total Clients (EIG)*</td><td className="clstd">{isNewParentNeeded === "1" ? formik.values.parentTotalClients : formik.values.parentTotalClients.name}</td></tr>}
                      <tr className="clstr"><td className="clstd">Select New Parent Needed (Hyperion)*</td><td className="clstd">{formik.values.newParentNeededHyperion.name}</td></tr>
                      {(isNewUltimateParentNeeded === "1" || isNewUltimateParentNeeded === "0") && <tr className="clstr"><td className="clstd">Parent in Total Clients (Hyperion)*</td><td className="clstd">{isNewUltimateParentNeeded === "1" ? formik.values.parentTotalClientsHyperion : formik.values.parentTotalClientsHyperion.name}</td></tr>}
                    </tbody>
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>State the Direct Parent in these client hierarchies</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr"><td className="clstd">Total Clients - By Manager*</td><td className="clstd">{formik.values.totalClientsByManager.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Select Contracting Entity*</td><td className="clstd">{formik.values.legalEntity.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Total Clients - Contracted by Country*</td><td className="clstd">{contractByCountry}</td></tr>
                    </tbody>
                  </table>
                </Card>}
              {(formik.values.segmentAttribute.name !== "" || formik.values.verticalAttribute.name !== "" || formik.values.geoAttribute.name !== "" || formik.values.clientPortfolio.name !== "" || formik.values.alternateClientRollups1.name !== "" || formik.values.alternateClientRollups2.name !== "" || formik.values.hypergrowthClient.name !== "" || formik.values.timezone.name !== "" || formik.values.requestedStartDate !== "" || (formik.values.channeltype as DropdownData[]).length > 0) &&
                <Card className="m-2">
                  <table className="tbleven clstable">
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>Attributes</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr"><td className="clstd">Segment Attribute*</td><td className="clstd">{formik.values.segmentAttribute.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Vertical Attribute*</td><td className="clstd">{formik.values.verticalAttribute.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Geo Attribute*</td><td className="clstd">{formik.values.geoAttribute.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Client Portfolio*</td><td className="clstd">{formik.values.clientPortfolio.name}</td></tr>
                    </tbody>
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>Other Client Details</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr"><td className="clstd">Alternate Client Rollups #1</td><td className="clstd">{formik.values.alternateClientRollups1.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Alternate Client Rollups #2</td><td className="clstd">{formik.values.alternateClientRollups2.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Hypergrowth Client</td><td className="clstd">{formik.values.hypergrowthClient.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Timezone*</td><td className="clstd">{formik.values.timezone.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Channel</td><td className="clstd">{(formik.values.channeltype as DropdownData[]).map(c => c.name).join(", ")}</td></tr>
                      <tr className="clstr"><td className="clstd">Requested Start Date (MM/DD/YYYY)</td><td className="clstd">{formik.values.requestedStartDate ? ((formik.values.requestedStartDate.getMonth() + 1).toString().length > 1 ? (formik.values.requestedStartDate.getMonth() + 1) : "0" + (formik.values.requestedStartDate.getMonth() + 1)) + "/" + formik.values.requestedStartDate.getDate() + "/" + formik.values.requestedStartDate.getFullYear() : formik.values.requestedStartDate}</td></tr>
                    </tbody>
                  </table>
                </Card>}
              {(formik.values.corpAllocations.name !== "" || formik.values.siteAllocations.name !== "" || formik.values.countryAllocations.name !== "" || formik.values.regionalAllocations.name !== "" || formik.values.cmsCgsAllocations.name !== "" || formik.values.engageSegmentAllocations.name !== "" || formik.values.siteAllocationsAtHome.name !== "" || formik.values.segmentAllocations.name !== "" || formik.values.siteAllocationsFcr.name !== "" || formik.values.countryAllocationsFcr.name !== "") &&
                <Card className="m-2">
                  <table className="tblodd clstable">
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>Allocations</b></th></tr></thead>
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>Corporate Allocations</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr"><td className="clstd">Corp Allocations*</td><td className="clstd">{formik.values.corpAllocations.name}</td></tr>
                    </tbody>
                    {showAllocations && (
                      <>
                        <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>Engage Allocations</b></th></tr></thead>
                        <tbody>
                          <tr className="clstr"><td className="clstd">Site Allocations*</td><td className="clstd">{formik.values.siteAllocations.name}</td></tr>
                          <tr className="clstr"><td className="clstd">Country Allocations*</td><td className="clstd">{formik.values.countryAllocations.name}</td></tr>
                          <tr className="clstr"><td className="clstd">Regional Allocations*</td><td className="clstd">{formik.values.regionalAllocations.name}</td></tr>
                          <tr className="clstr"><td className="clstd">CMS/CGS Allocations*</td><td className="clstd">{formik.values.cmsCgsAllocations.name}</td></tr>
                          <tr className="clstr"><td className="clstd">Engage Segment Allocations*</td><td className="clstd">{formik.values.engageSegmentAllocations.name}</td></tr>
                        </tbody>
                        <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>At Home Allocations</b></th></tr></thead>
                        <tbody>
                          <tr className="clstr"><td className="clstd">Site Allocations</td><td className="clstd">{formik.values.siteAllocationsAtHome.name}</td></tr>
                          <tr className="clstr"><td className="clstd">Segment Allocations</td><td className="clstd">{formik.values.segmentAllocations.name}</td></tr>
                        </tbody>
                      </>
                    )}
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>FCR Allocations</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr"><td className="clstd">Site Allocations*</td><td className="clstd">{formik.values.siteAllocationsFcr.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Country Allocations*</td><td className="clstd">{formik.values.countryAllocationsFcr.name}</td></tr>
                    </tbody>
                  </table>
                </Card>}
              {(segmentname === "Engage" || segmentname === "Percepta" || segmentname === "Digital") && (formik.values.managedBy !== "" || formik.values.supportGroups.name !== "" || formik.values.opsVP !== "") &&
                <Card className="m-2">
                  <table className="tbleven clstable">
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>AskNow Business Service</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr"><td className="clstd">Managed By*</td><td className="clstd">{formik.values.managedBy}</td></tr>
                      <tr className="clstr"><td className="clstd">Support Group*</td><td className="clstd">{formik.values.supportGroups.name}</td></tr>
                      <tr className="clstr"><td className="clstd">Ops VP*</td><td className="clstd">{formik.values.opsVP}</td></tr>
                    </tbody>
                  </table>
                </Card>}
            </div>
          </Card>
        </div>
        {(!issubmitsuccess && !issavesuccess) &&
          <div className="btnnav col-md-8">
            <div className="childfooterleft">
              {activeIndex !== 0 &&
                <Button onClick={() => onHideShowClick((activeIndex == 0) ? activeIndex : activeIndex - 1)} type="button" label="Back" className="btnBack" outlined size="large" />}
            </div>
            <div className="childfooterright">
              {((segmentname !== "Engage" && segmentname !== "Percepta" && segmentname !== "Digital" && activeIndex !== 4) || ((segmentname === "Engage" || segmentname === "Percepta" || segmentname === "Digital") && activeIndex !== 5)) &&
                <Button onClick={() => onHideShowClick(props.mode !== "View" ? ((activeIndex <= 3) ? activeIndex + 1 : ((segmentname === "Engage" || segmentname === "Percepta" || segmentname === "Digital") && activeIndex <= 4) ? activeIndex + 1 : activeIndex) : ((activeIndex <= 2) ? activeIndex + 1 : ((segmentname === "Engage" || segmentname === "Percepta" || segmentname === "Digital") && activeIndex <= 3) ? activeIndex + 1 : activeIndex))} type="button" label="Next" className="btnNext" size="large" disabled={activeIndex === 0 && hasDisallowedNameCharacters(formik.values.clientReportingAliasName)} />}
              {((segmentname !== "Engage" && segmentname !== "Percepta" && segmentname !== "Digital" && activeIndex === 4 && props.mode !== "View") || ((segmentname === "Engage" || segmentname === "Percepta" || segmentname === "Digital") && activeIndex == 5 && props.mode !== "View")) &&
                <div>
                  <Button onClick={() => saveCPPRequest(false)} type="button" label="Save as Draft" className="btnNext" size="large" />
                  <Button onClick={() => saveCPPRequest(true)} type="submit" label="Submit" className="btnNext" size="large" />
                </div>}
            </div>
          </div>}
        {((issubmitsuccess || issavesuccess) && props.requestDetails == null) &&
          <div className="btnnav col-md-8">
            <div className="childfooterleft"></div>
            <div className="childfooterright">
              <Button onClick={() => navigate(NEWCLIENTREQUEST)} type="button" label="Create Another Client" className="btnNext" size="large" />
            </div>
          </div>}
        {(((props.mode === "Edit") && (issubmitsuccess || issavesuccess))) &&
          <div className="btnnav col-md-8">
            <div className="childfooterleft"></div>
            <div className="childfooterright">
              <Button onClick={() => HideDialog(true)} type="button" label="Close" className="btnNext" size="large" />
            </div>
          </div>}
        <div>
          {showLoader && !showHeader && (
            <div className={spinnerClassName}>
              <Spinner />
            </div>
          )}
        </div>
      </form>
    </>
  );
};